import store from '@/store';
import {resolveMarketplaceFeatureEnabled} from '@/utils/posthog';

export default (to, from, next) => {
  const user = store.getters['auth/user'];
  const dashboardPath = window.app.findRouteByName('dashboard').path;

  resolveMarketplaceFeatureEnabled(user).then((enabled) => {
    if (enabled) {
      return next();
    }

    window.app.d(`[marketplaceRolloutMiddleware] Redirected to ${dashboardPath}`);

    return next({path: dashboardPath});
  });
};
